/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { FileAddOutlined } from "@ant-design/icons";
import ProductOrderCandidateTable from "./ProductOrderCandidateTable";

const mngConfig = {
  title: "",
  action: "create",
  record: null,
};

const ProductionOrderAccess = () => {
  const navigate = useNavigate();

  const handleAdd = () => {
    navigate("manage/create", {
      state: {
        config: {
          ...mngConfig,
          title: "Create Production Order",
          action: "create",
          record: null,
          produceType: "FG",
        },
      },
    });
  };

  const handleEdit = (record) => {
    navigate("manage/edit", {
      state: {
        config: {
          ...mngConfig,
          title: "Edit Production Order",
          action: "edit",
          record,
          produceType: record?.produce_type || "FG",
        },
      },
    });
  };

  const handleView = (record) => {
    navigate("manage/view", {
      state: {
        config: {
          ...mngConfig,
          title: "View Production Order",
          action: "view",
          record,
          produceType: record?.produce_type || "FG",
        },
      },
    });
  };

  return (
    <div className="productionorder-access">
      <ProductOrderCandidateTable
        handleEdit={handleEdit}
        handleView={handleView}
        headerExtra={
          <Button
            size="small"
            className="bn-action bn-center bn-primary-outline justify-center"
            icon={<FileAddOutlined style={{ fontSize: ".9rem" }} />}
            onClick={handleAdd}
          >
            Create Production Order
          </Button>
        }
      />
    </div>
  );
};

export default ProductionOrderAccess;
